// extracted by mini-css-extract-plugin
export default {"actionTab":"ActionTab_actionTab__fAYd3","active":"ActionTab_active__wmVg2","description":"ActionTab_description__lfLxW"};